module.exports = __webpack_public_path__ + "img/Webp.net-resizeimage.637f4a93.png";